<template>
<div class="l-base">
  <router-view />
</div>
</template>

<style lang="scss" scoped>
.l-base{
  min-height: 100vh;
  padding: 90px 0 0;
  background-color: $color_white_dark;
  background-image: url('/assets/img/img_bg.png');
  background-repeat: no-repeat;
}
</style>

<script>
</script>
